import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { FeatureFlagServiceProps } from '@mews/framework';
import { openMessageCenter, closeMessageCenter, handleCloseAction } from '../../actions/utils';
import { addThread, messagingModuleInit } from '../../actions/threads';
import { sendMessage } from '../../actions/messages';
import { currentThread as getCurrentThreadJS, getCurrentThreadId } from '../../selectors/threads';
import { currentThreadDraft, currentThreadMembers as getCurrentThreadMembersJS } from '../../selectors';
import { Member, Thread } from '../../types';

type GetCurrentThread = (state: ApplicationState) => Thread;
const getCurrentThread = getCurrentThreadJS as GetCurrentThread;

type GetCurrentThreadMembers = (state: ApplicationState) => Member[];
const getCurrentThreadMembers = getCurrentThreadMembersJS as GetCurrentThreadMembers;

interface StateProps {
    currentThreadId: string;
    currentThread: Thread;
    currentThreadDraft: string;
    currentThreadMembers: Member[];
}

interface DispatchProps {
    onSendMessage: (threadId: string, text: string) => void;
    onPostThread: (thread: Thread, text: string, members: Member[]) => void;
    onMount: () => void;
    onUnmount: () => void;
    onInit: ({ threadId }: { threadId?: string }) => void;
    handleClose: () => void;
}

const connectMessagesApp = connect<StateProps, DispatchProps, FeatureFlagServiceProps, ApplicationState>(
    createStructuredSelector({
        currentThread: getCurrentThread,
        currentThreadDraft,
        currentThreadMembers: getCurrentThreadMembers,
        currentThreadId: getCurrentThreadId,
    }),
    (dispatch: CommanderThunkDispatch) => ({
        onSendMessage: (threadId, text) => dispatch(sendMessage(threadId, text)),
        onPostThread: (thread, text, members) => dispatch(addThread(thread, text, members)),
        onMount: () => dispatch(openMessageCenter()),
        onUnmount: () => dispatch(closeMessageCenter()),
        onInit: async ({ threadId }) => dispatch(messagingModuleInit({ threadId })),
        handleClose: () => dispatch(handleCloseAction()),
    })
);

export default connectMessagesApp;
